import { FC, useContext, useState } from 'react';

import { Button, Modal } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import s from './RejectPaymentModal.module.scss';

interface IRejectPaymentModalProps {
  closeModal: () => void;
  onClick: () => Promise<unknown>;
}

export const RejectPaymentModal: FC<IRejectPaymentModalProps> = ({
  closeModal,
  onClick,
}) => {
  const { t } = useContext(LocalizationContext);
  const [isLoading, setIsLoading] = useState(false);
  return (
    <Modal onClose={closeModal} className={s.container}>
      <header>{t('payment.refund')}</header>
      <div data-onboarding="refund-confirm">
        <Button
          isLoading={isLoading}
          fullWidth
          className={s.button}
          onClick={() => {
            setIsLoading(true);
            onClick().finally(() => {
              setIsLoading(false);
              closeModal();
            });
          }}
        >
          {t('confirm')}
        </Button>
      </div>
    </Modal>
  );
};
